export default __webpack_public_path__ + "static/media/text-line.dafbdfcc.svg";